import styled from "styled-components";

export const StyledUnderline = styled.span`
  border-bottom: 1px dashed var(--gray-900);
  padding-bottom: 1px;
`;
